import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Ng2DeviceService } from 'ng2-device-detector';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';
declare var X2JS: any;
declare var Crypto: any;
declare var CryptoService: any;

@Injectable()
export class utilityService {
  CryptoObj: any;
  cryptoService: any;
  x2js: any;
  _self: any;
  busy: Subscription;
  serviceExp: boolean = false;
  BeneficiaryRelations: any;
  private subject = new Subject<any>();
  constructor(
    private http: Http,
    private httpClient: HttpClient,
    private router: Router,
    domSanitizer: DomSanitizer,
    public modal: Modal,
    private deviceService: Ng2DeviceService,
    private translate: TranslateService // private vcRef: ViewContainerRef
  ) {
    this.x2js = X2JS;
    this._self = this;
    this.CryptoObj = Crypto;
    this.cryptoService = new CryptoService();
  }

  getCountryImage(country) {
    const url = AppSettings.getCountryUrl(country);
    return this.restGetImage(url, true);
  }
  getIceImage(suffix) {
    const url = AppSettings.baseImageURL + suffix;
    return this.restIceGetBlob(url, true);
  }
  getBackGroundImage(Envelope) {
    return this.restPost(Envelope, AppSettings.ICEMasterService + '/GetBackgroundImage');
  }

  setBackGroundImage(response) {
    if (response.StatusCode == 10000) {
      if (response.LoginBackgroundImage != null && response.LoginBackgroundImage != undefined) {
        sessionStorage.loginBGImage = 'data:image/gif;base64,' + response.LoginBackgroundImage;
      } else {
        sessionStorage.loginBGImage = '';
      }
    } else {
      sessionStorage.loginBGImage = '';
    }
  }

  // SavePost without Action
  soapPostwithoutAction(envelop: string, SOAPurl: string) {
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/soap+xml; charset=utf-8');
    let options = new RequestOptions({ headers: headers }); // Create a request option
    return this.http
      .post(SOAPurl, envelop, options)
      .map(res => {
        this.onResponse(res);
        return this.getJsonFromXML(res);
      })
      .catch(err => {
        return this.openErrorPopup(err);
      });
    // .last();
  }
  onResponse(res) {
    let resJSON = this.getJsonFromXML(res);
    const objName = Object.keys(resJSON.Envelope.Body)[0];
    if (resJSON.Envelope.Body[objName].StatusCode == 20001) {
      this.openPopupSessionExpired();
      console.log(res.StatusMessage);
      return false;
    }

    if (this.isNull(resJSON.Envelope.Body[objName].Session) && this.isNull(resJSON.Envelope.Body[objName].Session.T1)) {
      if (this.getObjectText(resJSON.Envelope.Body[objName].Session.T1) != '') {
        //  console.log('Old Session' + sessionStorage.T1);
        //   console.log('New Session' + this.getObjectText(resJSON.Envelope.Body[objName].Session.T1));
        sessionStorage.T1 = this.getObjectText(resJSON.Envelope.Body[objName].Session.T1).replace(/\s/g, '');
      }
    }
    if (this.isNull(resJSON.Envelope.Body[objName].SessionObject) && this.isNull(resJSON.Envelope.Body[objName].SessionObject.T1)) {
      try {
        if (this.getObjectText(resJSON.Envelope.Body[objName].SessionObject.T1) != '') {
          sessionStorage.T1 = this.getObjectText(resJSON.Envelope.Body[objName].SessionObject.T1).replace(/\s/g, '');
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  }
  restPost(envelop: string, SOAPurl: string, handelError: boolean = true) {
    let headers: Headers = new Headers();
    const lang = sessionStorage.langCode != undefined ? sessionStorage.langCode : 'en';

    if (SOAPurl.indexOf('ICEMaster') > 0) {
      headers.append('LanguageCode', lang);
      headers.append('App_key', '300323db-c982-4e96-90f0-5626920e18a4');
      const DeviceDetail = this.deviceService.getDeviceInfo();
      const suffixDeviceDetails = {
        DeviceID: localStorage.sessionId,
        DeviceOS: DeviceDetail.os,
        DeviceType: DeviceDetail.device,
        DeviceBrowser: DeviceDetail.browser,
        DeviceUserAgent: DeviceDetail.userAgent,
        DeviceOS_version: DeviceDetail.os_version,
        EndIPAddress: sessionStorage.EndUserIP,
        Appversion: AppSettings.Appversion,
        Platform: AppSettings.Platform
      };

      let envelopJson = JSON.parse(envelop);
      envelopJson.DeviceInfo = suffixDeviceDetails;
      envelop = JSON.stringify(envelopJson);
    }
    headers.append('Content-Type', 'application/json; charset=utf-8');
    let options = new RequestOptions({ headers: headers }); // Create a request option
    return this.http
      .post(SOAPurl, envelop, options)
      .map(res => {
        const data: any = res;
        if (data._body == '' || data._body == null) {
          return { data };
        } else {
          this.onRestResponse(data.json());
          return data.json();
        }
      })
      .last()
      .catch(err => {
        if (handelError == false) return
        return this.openErrorPopup(err);
      });
  }

  getRequirements (next: Observable<void>) {

    let getRequirementsRequest = {
      LanguageCode: "en",
      Session: {
          T1: "",
          T2: sessionStorage.T2
      }
    };

    return this.httpClient.post<any>("https://ecom-qa.intercambioexpress.com/9010/RequirementsService.svc/Get", getRequirementsRequest).catch((err, caught) => {
      return next;
    });
  }

  postRequirements (req: any, next: Observable<void>) {

    req.LanguageCode = "en",
    req.Session = {
        T1: "",
        T2: sessionStorage.T2
    }

  return this.httpClient.post<any>("https://ecom-qa.intercambioexpress.com/9010/RequirementsService.svc/Onfido", req).catch((err, caught) => {
      return next;
    });
  }

  downloadPDF(envelop: string, SOAPurl: string, contentType?: number): any {
    const headers: Headers = new Headers();
    if (contentType === 1) {
      headers.append('Content-Type', 'application/soap+xml; charset=utf-8');
    } else {
      headers.append('Content-Type', 'application/json; charset=utf-8');
    }
    const options = new RequestOptions({ headers: headers }); // Create a request option
    return this.http
      .post(SOAPurl, envelop, options)
      .map(res => {
        return new Blob([res.blob()], { type: 'application/pdf' });
      })
      .catch(err => {
        return this.openErrorPopup(err);
      });
  }

  onRestResponse(res) {
    if (res.StatusCode == 20001) {
      console.log(res.StatusMessage);
      this.openPopupSessionExpired();
      return false;
    }
    if (this.isNull(res.Session) && this.isNull(res.Session.T1)) {
      if (this.getObjectText(res.Session.T1) != '') {
        console.log('Old Session' + sessionStorage.T1);
        console.log('New Session' + res.Session.T1);
        sessionStorage.T1 = res.Session.T1.replace(/\s/g, '');
      }
    }
  }
  restGet(SOAPurl: string, isheader: boolean, handelError: boolean = true) {
    let headers = new Headers({});
    const lang = sessionStorage.langCode != undefined ? sessionStorage.langCode : 'en';
    if (isheader == true) {
      headers = new Headers({ LanguageCode: lang });
    }
    if (SOAPurl.indexOf('ICEMaster') > 0) {
      headers.append('App_key', '300323db-c982-4e96-90f0-5626920e18a4');
    }
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(SOAPurl, options)
      .map(res => res.json())
      .last()
      .catch(err => {
        if (handelError == false) return
        return this.openErrorPopup(err);
      });
  }
  restGetImage(SOAPurl: string, isheader: boolean) {
    let headers = new HttpHeaders({});
    const lang = sessionStorage.langCode != undefined ? sessionStorage.langCode : 'en';
    if (isheader == true) {
      headers = new HttpHeaders({ LanguageCode: lang, App_key: '300323db-c982-4e96-90f0-5626920e18a4' });
    }
    return this.httpClient
      .get(`${SOAPurl}`, {
        headers: headers,
        responseType: 'blob'
      })
      .map(res => {
        var urlCreator = window.URL;
        var imageUrl = urlCreator.createObjectURL(res);
        return imageUrl;
      })
      .catch(err => {
        return this.openErrorPopup(err);
      });
  }
  restIceGetBlob(SOAPurl: string, isheader: boolean): any {
    let headers = new HttpHeaders({});
    const lang = sessionStorage.langCode != undefined ? sessionStorage.langCode : 'en';
    if (isheader == true) {
      headers = new HttpHeaders({ LanguageCode: lang, App_key: '300323db-c982-4e96-90f0-5626920e18a4' });
    }
    return this.httpClient
      .get(`${SOAPurl}`, {
        headers: headers,
        responseType: 'blob'
      })
      .map(res => {
        return res;
      })
      .catch(err => {
        return this.openErrorPopup(err);
      });
  }
  restPostImage(SOAPurl: string, body: any) {
    let headers = new HttpHeaders({});
    const lang = sessionStorage.langCode != undefined ? sessionStorage.langCode : 'en';
    headers = new HttpHeaders({ LanguageCode: lang, App_key: '300323db-c982-4e96-90f0-5626920e18a4' });
    return this.httpClient
      .post(`${SOAPurl}`, {
        headers: headers,
        responseType: 'blob'
      })
      .map(res => {
        var urlCreator = window.URL;
        var imageUrl = urlCreator.createObjectURL(res);
        return imageUrl;
      })
      .catch(err => {
        return this.openErrorPopup(err);
      });
  }

  // Function for validating string null
  isNull(val: string): string {
    //return (val != null && val !== undefined && val !== '[object Object]' ? encodeURIComponent(val) : '');
    return val != null && val !== undefined && val !== '[object Object]' ? val : '';
  }
  // Function for parsing http request
  fixedEncodeURIComponent(str: string) {
    // return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    //   return '%' + c.charCodeAt(0).toString(16);
    // });
  }
  public getJsonFromXML(res): any {
    const x2js = new X2JS();
    const resJSON = x2js.xml_str2json(res._body);
    return resJSON;
  }

  /*  set and get BeneficiaryRelations */
  getBeneficiaryRelations() {
    const response = JSON.parse(localStorage.BeneficiaryRelations);
    let jsonObj = [];
    response.filter(function (item) {
      jsonObj.push(
        item.filter(function (obj) {
          return obj.Language.toUpperCase() === sessionStorage.langCode.toUpperCase();
        })[0].Name
      );
    });
    return jsonObj;
  }

  setBeneficiaryRelations(response) {
    if (response.BeneficiaryRelation != null && response.BeneficiaryRelation != undefined) {
      localStorage.BeneficiaryRelations = JSON.stringify(response.BeneficiaryRelation);
    }
  }

  /*  set and get TransferReasons */
  getTransferReasons() {
    const response = JSON.parse(localStorage.TransferReasons);
    let jsonObj = [];
    response.filter(function (item) {
      jsonObj.push(
        item.filter(function (obj) {
          return obj.Language.toUpperCase() === sessionStorage.langCode.toUpperCase();
        })[0].Name
      );
    });
    return jsonObj;
  }

  setTransferReasons(response) {
    if (response.TransferReason != null && response.TransferReason != undefined) {
      localStorage.TransferReasons = JSON.stringify(response.TransferReason);
    }
  }

  handleError(error: any) {
    console.error(error);
    return Observable.throw(error.message || error);
  }
  public getJsonResponse(res): any {
    const x2js = new X2JS();
    let resJSON = x2js.xml_str2json(res);
    return resJSON;
  }
  getObjectText(obj) {
    if (obj === undefined || obj === null) {
      return '';
    }

    if (typeof obj === 'object') {
      return obj.__text === undefined ? '' : obj.__text;
    } else {
      return obj;
    }
  }
  getObjectNumber(obj) {
    if (obj === undefined || obj === null) {
      return 0;
    }

    if (typeof obj === 'object') {
      return obj.__text === undefined ? '' : obj.__text;
    } else {
      return obj;
    }
  }

  getPattern(prefix: string, mask: string, suffix: string) {
    let stringBuilder: any = '';
    let i;
    for (i = 0; i < mask.length; i++) {
      let maskValue: any;
      maskValue = mask.charAt(i);
      if (maskValue == '0') stringBuilder += '[0-9]';
      else if (maskValue == '9') stringBuilder += '([0-9]|\\s)';
      else if (maskValue == 'L') stringBuilder += '[a-zA-Z]';
      else if (maskValue == '?') stringBuilder += '([a-zA-Z]|\\s)';
    }
    if (prefix == '') prefix = '';
    if (suffix == '') suffix = '';
    let pattern: string;
    pattern = `^${prefix}${stringBuilder}${suffix}$`;
    return pattern;
  }

  getArray(obj) {
    try {
      if (!(Object.prototype.toString.call(obj) === '[object Array]')) {
        let arrCol = [];
        arrCol.push(obj);
        return arrCol;
      } else return obj;
    } catch (error) {
      return [];
    }
  }
  getTransStatus(transStatus) {
    if (AppSettings.redStatus.indexOf(transStatus.toUpperCase()) !== -1) {
      return -1;
    }
  }

  getCustomerCarePhone(CountryObject) {
    if (CountryObject.CustomerCareNumber && CountryObject.CustomerCareNumber != undefined) {
      return CountryObject.CustomerCareNumber;
    }
  }
  formatDate(date) {
    if (date != '') {
      return moment(date).format('MM/DD/YYYY');
    }
  }

  openPopupSessionExpired() {
    // this.modal.overlay.defaultViewContainer = this.vcRef;
    const modalData: any = {};
    const self = this;
    this.translate.use(sessionStorage.langCode).subscribe(data => {
      modalData.Action = this.translate.instant('Common_lblOk');
      modalData.Title = this.translate.instant('Common_lblInfo').toString();
      modalData.Message = this.translate.instant('SessionExpirePopup_desc').toString();
      if (self.serviceExp == false) {
        self.serviceExp = true;
        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
          obj.onDestroy.subscribe(error => {
            self.serviceExp = false;
            if (modalData.next == 'yes') {
              sessionStorage.removeItem('KeyUID');
              sessionStorage.removeItem('T1');
              sessionStorage.removeItem('T2');
              self.router.navigate(['/login']);
              // this.router.navigateByUrl('/login');
            } else {
            }
          });
        });
      }
    });
  }

  openErrorPopup(err): any {
    // this.modal.overlay.defaultViewContainer = this.vcRef;
    this.translate.use(sessionStorage.langCode).subscribe(data => {
      const modalData: any = {};
      const self = this;
      modalData.Action = this.translate.instant('Common_lblOk');
      modalData.Title = this.translate.instant('Common_lblOops').toString();
      modalData.Message = this.translate.instant('Message_errorMessage').toString();
      try {
        if (err._body != undefined) {
          let errObj = JSON.parse(err._body);
          if (errObj.Errors != undefined && errObj.Errors.length > 0) {
            let code = errObj.Errors[0].Code;
            if (code == enumStatusCodeList.InvalidField) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_InvalidField_3000');
            } else if (code == enumStatusCodeList.Declined) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_Declined_3001');
            } else if (code == enumStatusCodeList.NotSufficientFunds) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_NotSufficientFunds_3002');
            } else if (code == enumStatusCodeList.PaymentProcessorError) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_PaymentProcessorError_3004');
            } else if (code == enumStatusCodeList.Timeout) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_Timeout_3005');
            } else if (code == enumStatusCodeList.FundingIsNotDebitCard) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_FundingIsNotDebitCard_3006');
            } else if (code == enumStatusCodeList.InvalidCardRegisterRequest) {
              modalData.Message = this.translate.instant('CardEnrolmentError_Msg_InvalidCardRegisterRequest_3007');
            } else {
              modalData.Message = this.translate.instant('Message_errorMessage');
            }
          }
        }
      } catch (error) {
        modalData.Message = this.translate.instant('Message_errorMessage').toString();
      }

      if (self.serviceExp == false) {
        self.serviceExp = true;
        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
          obj.onDestroy.subscribe(error => {
            self.serviceExp = false;
            // if (modalData.next == 'yes') {
            //   sessionStorage.removeItem('KeyUID');
            //   sessionStorage.removeItem('T1');
            //   sessionStorage.removeItem('T2');
            //   self.router.navigate(['/login']);
            //   // this.router.navigateByUrl('/login');
            // } else {
            // }
          });
        });
      }
    });
  }

  AESEncrypt(text) {
    const KEY = localStorage.sessionId;
    const md5Key = CryptoJS.MD5(KEY);
    const keyBytes = this.CryptoObj.util.wordsToBytes(md5Key.words);
    const IV = localStorage.sessionId;
    const MODE = new Crypto.mode.CBC(Crypto.pad.pkcs7);
    const options = { iv: this.CryptoObj.charenc.UTF8.stringToBytes(IV), asBytes: true, mode: MODE };
    const input_bytes = this.CryptoObj.charenc.UTF8.stringToBytes(text);
    const encrypted = this.CryptoObj.AES.encrypt(input_bytes, keyBytes, options);
    const encryptedText = this.CryptoObj.util.bytesToBase64(encrypted);
    return encryptedText;
  }

  AESDecrypt(encryptedText) {
    const KEY = localStorage.sessionId;
    const md5Key = CryptoJS.MD5(KEY);
    const keyBytes = this.CryptoObj.util.wordsToBytes(md5Key.words);
    const IV = localStorage.sessionId;
    const MODE = new Crypto.mode.CBC(Crypto.pad.pkcs7);
    const options = { iv: this.CryptoObj.charenc.UTF8.stringToBytes(IV), asBytes: true, mode: MODE };
    const output_bytes = this.CryptoObj.util.base64ToBytes(encryptedText);
    const output_plaintext_bytes = this.CryptoObj.AES.decrypt(output_bytes, keyBytes, options);
    const decryptedText = this.CryptoObj.charenc.UTF8.bytesToString(output_plaintext_bytes);
    return decryptedText;
  }

  jicCompressImage(source_img_obj, quality, output_format, size) {
    
    console.log("utility service - compress");
    return Observable.create(observer => {
      let cvs = document.createElement('canvas');
      let image = new Image();
      image.src = 'data:image/jpeg;base64,' + source_img_obj;
     
      
      image.onload = function () {
     
        if(size>4*1000000 && size >=13*1000000 ){
                let newWidth =1200;
                let newHeight = 1200;
                cvs.width = newWidth;
                cvs.height = newHeight;
                let ctx = cvs.getContext('2d');
                ctx.drawImage(image, 0, 0, newWidth, newHeight);
                let data = cvs.toDataURL('image/jpeg:base64', 1); 
                console.log( data);
                observer.next(data);
        observer.complete();
        }else if(size>5*1000000 && size <=6*1000000 ){
                let newWidth =1400;
                let newHeight = 1400;
                cvs.width = newWidth;
                cvs.height = newHeight;
                let ctx = cvs.getContext('2d');
                ctx.drawImage(image, 0, 0, newWidth, newHeight);
                let data = cvs.toDataURL('image/jpeg:base64', 1);
                console.log( data);
                observer.next(data);
        observer.complete();
        }else if(size>6*1000000 && size <=7*1000000 ){
          
                let newWidth =1560;
                let newHeight = 1560;
                cvs.width = newWidth;
                cvs.height = newHeight;
                let ctx = cvs.getContext('2d');
                ctx.drawImage(image, 0, 0, newWidth, newHeight);
                let data = cvs.toDataURL('image/jpeg:base64', 1);
                
                console.log( data);
                observer.next(data);
        observer.complete();
        }
        else if(size>4*1000000 && size <=4.5*1000000 ){
         
                let newWidth =1600;
                let newHeight = 1600;
                cvs.width = newWidth;
                cvs.height = newHeight;
                let ctx = cvs.getContext('2d');
                ctx.drawImage(image, 0, 0, newWidth, newHeight);
                let data = cvs.toDataURL('image/jpeg:base64', 1);
                
                console.log( data);
                observer.next(data);
        observer.complete();
        } else if(size>7*1000000 && size <=8*1000000 ){
         
          let newWidth =2500;
          let newHeight = 2000;
          cvs.width = newWidth;
          cvs.height = newHeight;
          let ctx = cvs.getContext('2d');
          ctx.drawImage(image, 0, 0, newWidth, newHeight);
          let data = cvs.toDataURL('image/jpeg:base64', 1);
          
          console.log( data);
          observer.next(data);
  observer.complete();
  } else if(size>8*1000000 && size <=10*1000000 ){
         
    let newWidth =1500;
    let newHeight = 1500;
    cvs.width = newWidth;
    cvs.height = newHeight;
    let ctx = cvs.getContext('2d');
    ctx.drawImage(image, 0, 0, newWidth, newHeight);
    let data = cvs.toDataURL('image/jpeg:base64', 1);
    
    console.log( data);
    observer.next(data);
observer.complete();
} else if(size>10*1000000 && size <=12*1000000 ){
         
  let newWidth =1100;
  let newHeight = 1100;
  cvs.width = newWidth;
  cvs.height = newHeight;
  let ctx = cvs.getContext('2d');
  ctx.drawImage(image, 0, 0, newWidth, newHeight);
  let data = cvs.toDataURL('image/jpeg:base64', 1);
  
  console.log( data);
  observer.next(data);
observer.complete();
} else if(size>12*1000000 && size <=13*1000000 ){
         
  let newWidth =1400;
  let newHeight = 1400;
  cvs.width = newWidth;
  cvs.height = newHeight;
  let ctx = cvs.getContext('2d');
  ctx.drawImage(image, 0, 0, newWidth, newHeight);
  let data = cvs.toDataURL('image/jpeg:base64', 1);
  
  console.log( data);
  observer.next(data);
observer.complete();
}
        else{
          cvs.height=image.height;
         cvs.width=image.width;
         console.log(cvs.height , cvs.width , +"i am in if 3rd ");
          cvs.getContext('2d').drawImage(image, 0, 0, image.width, image.height );
          let data = cvs.toDataURL('image/jpeg');
        console.log(data);
        observer.next(data);
        observer.complete();
        }
        
      }
    //   ...... "" console.log(image.width, image.height);
    //    const width = image.width > 4*1024 ? 4*1000 : image.width;
       
    //    const scaleFactor = width / image.width;
    //  cvs.width = width;
    //  console.log("scale factor" + scaleFactor);
    //    cvs.height = image.height * scaleFactor;"".....

         //cvs.width = Math.round(image.width / 2);
//  cvs.height = Math.round(image.height / 2);

        
        // cvs.width = Math.round(image.width / 2);
        // cvs.height = Math.round(image.height / 2);
      
     
        // cvs.width=image.width;
       
        // cvs.height=image.height;
        // cvs.getContext('2d').drawImage(image, 0, 0, cvs.width, cvs.height);
    });
  }

  validateDocNumPattern(docNum) {
    const pat = '^(\\d)(?:(.)\\1*|0?1?2?3?4?5?6?7?8?9?|9?8?7?6?5?4?3?2?1?0?)$';
    const regexp = new RegExp(pat);
    if (regexp.test(docNum) === true) {
      return true;
    } else {
      return false;
    }
  }

  roundOff(num: number) {
  // this source rounding off up to decimal
    return Math.round(num * 100) / 100;
  }
  // destRoundOff(num: number, country: string = "MX", cur: string = "MXN") {
  //   let roundingPlaces: number = 2;
  //   try {
  //     const CountryObj = JSON.parse(localStorage.CountryCollection).filter(data => data.CountryCode == country);
  //     if (CountryObj.length > 0) {
  //       const curencyObj = CountryObj[0].filter(data => data.CurrencyCode == cur);
  //       if (curencyObj.length > 0) {
  //         roundingPlaces = curencyObj[0].RoundingPlaces;
  //       }
  //     }
  //   } catch (error) {

  //   }


  //   return roundingPlaces;
  // }
  destRoundOff(num: number, roundingPlace: number = 2) {
    // this function is for  destination amount round off based roundingPlace available in on country and curency API from middleware
    return Number(num.toFixed(roundingPlace));
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/utility.service.ts